import { render, staticRenderFns } from "./CategoryTiles.vue?vue&type=template&id=d082224c&"
import script from "./CategoryTiles.vue?vue&type=script&lang=js&"
export * from "./CategoryTiles.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTiles.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports